import { Reporte607Service } from "services";
import { ResponseExceptionHandlerHelper } from "utils";

export const Reporte607Manager = (() => {
  const { handleException } = ResponseExceptionHandlerHelper();

  const imprimirPDF = (params) =>
    Reporte607Service.imprimirPDF(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.Data;
    });

  const descargarExcel = (params) =>
    Reporte607Service.descargarExcel(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  const descargarCSV = (params) =>
    Reporte607Service.descargarCSV(params).then((res) => {
      if (!res.Success) handleException(res);
      return res.blob;
    });

  return { imprimirPDF, descargarExcel, descargarCSV };
})();
